import { inject, Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import { IAddressApiService, IAddressApiServiceToken } from "../../api/address/address-api-service.interface";
import { AddressDto, AddressListGetQueryResult, AddressSetCommandResult, CountryListGetQueryResult } from "../../INTEGRA_Shop_Client";
import { IAddressService, IAddressServiceToken } from "./address-service.interface";

@Injectable({
  providedIn: 'root'
})
export class AddressService implements IAddressService {

  private readonly addressApiService: IAddressApiService;

  public constructor() {
    this.addressApiService = inject(IAddressApiServiceToken);
  }

  public countryListGet(filterDuplicatesByCountryCode?: boolean | undefined): Observable<CountryListGetQueryResult> {
    return this.addressApiService.countryListGet(filterDuplicatesByCountryCode);
  }

  public addressListGet(): Observable<AddressListGetQueryResult> {
    return this.addressApiService.addressListGet();
  }

  public addressSet(address?: AddressDto | undefined): Observable<AddressSetCommandResult> {
    return this.addressApiService.addressSet(address);
  }

  public addressDelete(address?: AddressDto | undefined): Observable<boolean> {
    return this.addressApiService.addressDelete(address);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddressServiceProvider: Provider[] = [
  { provide: IAddressServiceToken, useExisting: AddressService }
];
